module.exports = __webpack_public_path__ + "img/rooming.a3dfff92.jpg";